import PropTypes from "prop-types";
import clsx from "clsx";
import InputMask from "react-input-mask";

const EmergencyContactForm = ({
  currentFieldValue,
  updateField,
  invalidFieldValue,
  canValidateField,
  content,
  disabled,
}) => {
  return (
    <div className="p-16 border border-neutral-20 rounded-4 bg-neutral-10">
      {typeof content === "function" ? content() : null}
      <h4 className="title-2 font-semibold">Primary contact</h4>
      <SingleContact
        prefix="primary_"
        updateField={updateField.bind(this)}
        currentFieldValue={currentFieldValue.bind(this)}
        invalidFieldValue={invalidFieldValue}
        canValidateField={canValidateField}
        disabled={disabled}
      />
      <h4 className="title-2 font-semibold">Secondary contact</h4>
      <SingleContact
        prefix="secondary_"
        updateField={updateField.bind(this)}
        currentFieldValue={currentFieldValue.bind(this)}
        invalidFieldValue={invalidFieldValue}
        canValidateField={canValidateField}
        disabled={disabled}
      />
    </div>
  );
};

const SingleContact = ({
  updateField,
  currentFieldValue,
  prefix,
  invalidFieldValue,
  canValidateField,
  disabled,
}) => {
  return (
    <form>
      <div className="mb-16 flex flex-col">
        <label htmlFor={`${prefix}name`}>Name</label>
        <input
          id={`${prefix}name`}
          disabled={disabled}
          value={currentFieldValue(`${prefix}name`)}
          onChange={(e) => updateField(`${prefix}name`, e.target.value)}
        />
      </div>
      <div className="mb-16 flex flex-col">
        <label htmlFor={`${prefix}relationship`}>Relationship</label>
        <input
          id={`${prefix}relationship`}
          disabled={disabled}
          value={currentFieldValue(`${prefix}relationship`)}
          onChange={(e) => updateField(`${prefix}relationship`, e.target.value)}
        />
      </div>
      <div
        className={clsx(
          "mb-16 flex flex-col",
          invalidFieldValue &&
            invalidFieldValue(`${prefix}phone`) &&
            "border border-red-60"
        )}
        onBlur={() => canValidateField(`${prefix}phone`)}
      >
        <label htmlFor={`${prefix}phone`}>Phone number</label>
        <InputMask
          id={`${prefix}phone`}
          disabled={disabled}
          maskChar={null}
          placeholder="(999)-999-9999"
          mask="(999)-999-9999"
          value={currentFieldValue(`${prefix}phone`)}
          onChange={(e) => updateField(`${prefix}phone`, e.target.value)}
          type="tel"
        />
      </div>
      <div
        className={clsx(
          "mb-16 flex flex-col",
          invalidFieldValue &&
            invalidFieldValue(`${prefix}alternate_phone`) &&
            "border border-red-60"
        )}
        onBlur={() => canValidateField(`${prefix}alternate_phone`)}
      >
        <label htmlFor={`${prefix}alternate_phone`}>
          Alternative phone number
        </label>
        <InputMask
          id={`${prefix}alternate_phone`}
          disabled={disabled}
          maskChar={null}
          placeholder="(999)-999-9999"
          mask="(999)-999-9999"
          value={currentFieldValue(`${prefix}alternate_phone`)}
          onChange={(e) =>
            updateField(`${prefix}alternate_phone`, e.target.value)
          }
          type="tel"
        />
      </div>
    </form>
  );
};

EmergencyContactForm.propTypes = {
  currentFieldValue: PropTypes.func.isRequired,
  updateField: PropTypes.func.isRequired,
  invalidFieldValue: PropTypes.func,
  canValidateField: PropTypes.func,
  content: PropTypes.func,
  disabled: PropTypes.bool,
};

SingleContact.propTypes = {
  updateField: PropTypes.func.isRequired,
  currentFieldValue: PropTypes.func.isRequired,
  prefix: PropTypes.string.isRequired,
  invalidFieldValue: PropTypes.func,
  canValidateField: PropTypes.func,
  disabled: PropTypes.bool,
};

export default EmergencyContactForm;
